export default "__VITE_ASSET__Ba9r6rup__"